import type { AppDirective } from './types';

const InputFocus: AppDirective = {
  Name: 'app-input-focus' as const,
  Directive: {
    inserted(el) {
      if (el) {
        el.focus();
      }
    }
  }
};

export default InputFocus;
